import { GetPartnerFinanceMonthReportsService } from 'types/services';
import { m8API } from '../m8';
import { normalizeM8PartnerIncomeHistoryRecord } from '../utils/normalizeM8PartnerIncomeHistory';

export const getPartnerFinanceMonthReports: GetPartnerFinanceMonthReportsService = async (
  params
) => {
  const { page, partnerId } = params;

  let m8PartnerIncomeHistoryRecords;

  if (partnerId) {
    m8PartnerIncomeHistoryRecords = await m8API.admin.getPartnerIncomeHistory({
      page,
      idPartner: partnerId,
    });
  } else {
    m8PartnerIncomeHistoryRecords = await m8API.partner.getPartnerIncomeHistory(
      {
        page,
      }
    );
  }

  return m8PartnerIncomeHistoryRecords.map((m8PartnerIncomeHistoryRecord) =>
    normalizeM8PartnerIncomeHistoryRecord(
      m8PartnerIncomeHistoryRecord
    ).toPartnerFinanceMonthReport()
  );
};
